module.exports = __webpack_public_path__ + "static/media/profile_img.c4760c53.png";